export default __webpack_public_path__ + "static/media/V280_B_BD.e0aea524.pdf";